
export default {
    data() {
        return {
            // 存放了相关的属性名 数据  
            names: [],
            num: {
            },
            // 畅和
            changhe: [
                { text: '在线交费', to: '/rechargeBalance' },
                { text: '选课报名', to: '/' },
                { text: '在读课程', to: '/readingCourse' },
                // { text: '已完成课程', to: '/completedCourse' },
                { text: '证书', to: '/certificate' },
                // { text: '在线缴费', to: 'http://www.zzzjedu.com/index.php/Home/index/login.html' },
                { text: '个人中心', to: '/personalcenter' },
                { text: '公需课', to: 'https://hnzj.ghlearning.com/node/2819' },
            ],
            // 人才
            rencai: [
                { text: '首页', to: '/' },
                { text: '选课中心', to: '/classsearch' },
                { text: '政策法规', to: '/article?type=1' },
                { text: '通知公告', to: '/article?type=2' },
                { text: '在读课程', to: '/readingCourse' },
                { text: '已完成课程', to: '/completedCourse' },
                { text: '证书', to: '/certificate' },
            ],
            indexType: 2
        }
    },
    methods: {
        changeIndex(index) {
            if (this.$store.state.id || index == 1 || index == 2) {
                this.indexType = index;
            }
        },
		//检查路由
		config(){
			if(this.$store.state.store.id == 110){
				if(this.$route.path == '/rechargeBalance') this.indexType = 1;
				if(this.$route.path == '/') this.indexType = 2;
				if(this.$route.path == '/readingCourse') this.indexType = 3;
				if(this.$route.path == '/certificate') this.indexType = 4;
				if(this.$route.path == '/personalcenter') this.indexType = 5;
			}
			if(this.$store.state.store.id == 107){
				if(this.$route.path == '/') this.indexType = 1;
				if(this.$route.path == '/classsearch') this.indexType = 2;
				if(this.$route.path == '/article' && this.$route.query.type == 1) this.indexType = 3;
				if(this.$route.path == '/article' && this.$route.query.type == 2) this.indexType = 4;
				if(this.$route.path == '/readingCourse') this.indexType = 5;
				if(this.$route.path == '/completedCourse') this.indexType = 6;
				if(this.$route.path == '/certificate') this.indexType = 7;
			}
		}
    },
    created() {
        this.$getStoreId().then(shop_id => {
            let data = {
                offset: 0,
                length: 10,
                shop_id: shop_id
            }
            // ajax 请求 是可以传入一个对象 
            this.$post("navigation_bar/search", data).then(res => {
                // console.log(res)
                // 可以拿到相关的数据 
                //  res.data.result.data 这里得到的数据只有一条 是通过shop_id 的形式去筛选得到的 
                //  将id 作为自己的调条件 进入按请求的数据进行筛选 
                this.names = res.data.result.data
                // console.log('sasas',this.names.length)

                for (let i = 0; i < this.names.length; i++) {
                    // console.log(typeof this.names[i].url )
                    // 正则表达式进行判断 为空或者多个空格的时候 就进行处理，除取多个空格 得到最终的长度 
                    if (this.names[i].url.replace(/(^\s*)|(\s*$)/g, "").length == 0) {
                        this.names[i].url = "javascript:void(0)"
                    }
                }

            })
        })
    },
	mounted(){
		this.config()
	}
}